function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M38.7826 4L21.7391 21.0435C20 20.1739 18.087 19.6522 16.1739 19.6522C9.3913 19.6522 4 25.0435 4 31.8261C4 38.6087 9.3913 44 16.1739 44C22.9565 44 28.3478 38.6087 28.3478 31.8261C28.3478 29.7391 27.8261 27.8261 26.9565 26.2609L32.6957 20.5217H35.3043V17.913L36.1739 17.0435H38.7826V14.4348L39.6522 13.5652H42.2609V10.9565L44 9.21739V4H38.7826Z",
  stroke: "#ACB5BF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6957 37.913C14.1365 37.913 15.3044 36.7451 15.3044 35.3043C15.3044 33.8636 14.1365 32.6956 12.6957 32.6956C11.255 32.6956 10.087 33.8636 10.087 35.3043C10.087 36.7451 11.255 37.913 12.6957 37.913Z",
  stroke: "#FFD200",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgIconRental(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRental);
export default __webpack_public_path__ + "static/media/Icon-rental.645d0959.svg";
export { ForwardRef as ReactComponent };